/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { KTSVG } from '../../_metronic/helpers';
import { Col, Row, Table } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom';


interface WarehouseTransferInfo {
    id_inv_warehouse_transfers: number;
    id_projects: number;
    id_warehouse_from: number;
    id_warehouse_to: number;
    transfer_date: string;
    remarks: string;
    created_by: number;
    created_at: string;
    project: {
        id_projects: number;
        project_name: string;
    };
    warehouse_from: { id_warehouses: number, name: string, address: string, details: string };
    warehouse_to: { id_warehouses: number, name: string, address: string, details: string };
    transfer_rows: { 
        id_inv_warehouse_transfer_rows: number, 
        id_inv_warehouse_transfers: number, 
        id_items: number,  
        id_products: number, 
        quantity: number, 
        item: { 
            item_name: string, 
            item_code: string, 
            unit: { unit_name: string } 
        }, 
        product: { 
            product_name: string, 
            packing: string, 
            unit: { unit_name: string } 
        } 
    }[];
    creator: any;
    status: string;
}

interface RouteParams {
    idWarehouseTransfers: string;
}

export function WarehouseTransferDetails(props: any) {

    const [warehouseTransferInfo, setWarehouseTransferInfo] = useState<WarehouseTransferInfo | null>(null);
    const { idWarehouseTransfers }: RouteParams = useParams();

    useEffect(() => {
        if (idWarehouseTransfers !== undefined) {
            getWarehouseTransferInfo();
        }
    }, [idWarehouseTransfers])

    const getWarehouseTransferInfo = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse-transfer/' + idWarehouseTransfers,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                const data: WarehouseTransferInfo = resp.data;
                setWarehouseTransferInfo(data);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    return (<>
        <div className='card card-custom'>
            <div className='card-header card-header-stretch overflow-auto'>
                <div className='card-title'>
                    <h3 className='card-label'>Warehouse Transfer Details</h3>
                    <small className='text-muted'>| Information about the warehouse transfer</small>
                </div>
            </div>
            <div className="card-body">

            </div>
        </div>
        <Row>
            <Col md={4} className="pe-2">
                <div className="card card-flush overflow-hidden mt-3 ms-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Summary</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size='sm'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '50%' }}>ID</td>
                                    <td style={{ width: '50%' }}>{warehouseTransferInfo?.id_inv_warehouse_transfers}</td>
                                </tr>
                                <tr>
                                    <td>Project</td>
                                    <td>{warehouseTransferInfo?.project?.project_name}</td>
                                </tr>
                                <tr>
                                    <td>Warehouse From</td>
                                    <td>{warehouseTransferInfo?.warehouse_from?.name}</td>
                                </tr>
                                <tr>
                                    <td>Warehouse To</td>
                                    <td>{warehouseTransferInfo?.warehouse_to?.name}</td>
                                </tr>
                                <tr>
                                    <td>Transfer Date </td>
                                    <td>{warehouseTransferInfo?.transfer_date}</td>
                                </tr>
                                
                                <tr>
                                    <td>Remarks</td>
                                    <td>{warehouseTransferInfo?.remarks}</td>
                                </tr>
                                <tr>
                                    <td>Creator</td>
                                    <td>{warehouseTransferInfo?.creator.first_name + ' ' + warehouseTransferInfo?.creator.last_name + ' at ' + warehouseTransferInfo?.created_at}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
              
            </Col>
            <Col md={8} className="pt-2">
                {/* Items Section */}
                <div className="card card-flush overflow-hidden m-2 me-0">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Items</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>SL No</th>
                                    <th>Item Name</th>
                                    <th>Item Code</th>
                                    <th>Unit</th>
                                    <th className='text-center'>Transfer Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {warehouseTransferInfo?.transfer_rows?.filter(row => row.id_items).length > 0 ? (
                                    warehouseTransferInfo?.transfer_rows?.filter(row => row.id_items).map((transferItem, index) => (
                                        <tr key={'item-' + index}>
                                            <td>{index + 1}</td>
                                            <td>{transferItem?.item?.item_name}</td>
                                            <td>{transferItem?.item?.item_code}</td>
                                            <td>{transferItem?.item?.unit?.unit_name}</td>
                                            <td className='text-center'>
                                                <span className="badge badge-light-primary">
                                                    {Number(transferItem?.quantity)} {transferItem?.item?.unit?.unit_name}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className='text-center text-muted'>No items transferred</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>

                {/* Products Section */}
                <div className="card card-flush overflow-hidden m-2 me-0 mt-3">
                    <div className="card-header py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label fw-bold text-dark">Products</span>
                        </h3>
                    </div>
                    <div className="card-body pt-0">
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>SL No</th>
                                    <th>Product Name</th>
                                    <th>Packing</th>
                                    <th>Unit</th>
                                    <th className='text-center'>Transfer Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {warehouseTransferInfo?.transfer_rows?.filter(row => row.id_products).length > 0 ? (
                                    warehouseTransferInfo?.transfer_rows?.filter(row => row.id_products).map((transferProduct, index) => (
                                        <tr key={'product-' + index}>
                                            <td>{index + 1}</td>
                                            <td>{transferProduct?.product?.product_name}</td>
                                            <td>{transferProduct?.product?.packing}</td>
                                            <td>{transferProduct?.product?.unit?.unit_name}</td>
                                            <td className='text-center'>
                                                <span className="badge badge-light-success">
                                                    {Number(transferProduct?.quantity)} {transferProduct?.product?.unit?.unit_name}
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className='text-center text-muted'>No products transferred</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        <div className='row mt-4'>
                            <div className='col text-center'>
                                <Link className="btn btn-info btn-sm" to={`/warehouse-transfers`}>
                                    <KTSVG
                                        path='/media/svg/icons/Media/Back.svg'
                                        className='svg-icon-5 svg-icon'
                                    />		Back to Warehouse Transfers
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    </>
    )
}

export default WarehouseTransferDetails
